import React from 'react';
import { useParams } from 'react-router-dom';
import CityPage from './CityPage';
import StatePage from './StatePage';
import { getStateBySlug } from '../data/states';

// Resolver: same URL pattern serves both state hubs and city pages.
// State slugs are full state names (california, arizona, michigan);
// city slugs end with state abbr (-ca, -az, -mi). No collisions.
const MarketResolver = () => {
  const { slug } = useParams();
  if (getStateBySlug(slug)) {
    return <StatePage />;
  }
  return <CityPage />;
};

export default MarketResolver;
